import * as ReactDOM from 'react-dom/client';
import AppBiblio from './expert/AppBiblio.js';
import './expert.css';
import '../modal/modal.css';

const divRechercheExperte = document.getElementById(
  'search-expert-form-biblio',
);
const lienRechercheExperte = document.getElementById(
  'recherche-experte-link-biblio',
);
const root = ReactDOM.createRoot(
  document.getElementById('search-expert-form-biblio'),
);

const listLocalisationBiblio = JSON.parse(
  document.getElementById('listLocalisationBiblio').innerText,
);

divRechercheExperte.style.display = 'none';
const queryString = window.location.search;
if (queryString.includes('?')) {
  divRechercheExperte.style.display = 'block';
} else {
  divRechercheExperte.style.display = 'none';
}

lienRechercheExperte.addEventListener('click', function (event) {
  event.preventDefault();
  if (divRechercheExperte.style.display === 'none') {
    divRechercheExperte.style.display = 'block';
  } else {
    divRechercheExperte.style.display = 'none';
  }
});

root.render(<AppBiblio listLocalisationBiblio={listLocalisationBiblio} />);
